import { useState, type ReactNode } from "react";

import {
  DEFAULT_ORTHO_LOD_DEBUG,
  OrthoLodDebugContext,
  type OrthoLodDebugInfo,
} from "./orthoLodDebug";

interface OrthoLodDebugProviderProps {
  children: ReactNode;
}

const OrthoLodDebugProvider: React.FC<OrthoLodDebugProviderProps> = ({
  children,
}) => {
  const [orthoLodDebug, setOrthoLodDebug] = useState<OrthoLodDebugInfo>(
    DEFAULT_ORTHO_LOD_DEBUG,
  );

  return (
    <OrthoLodDebugContext
      value={{
        orthoLodDebug,
        setOrthoLodDebug,
      }}
    >
      {children}
    </OrthoLodDebugContext>
  );
};

export default OrthoLodDebugProvider;
